import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PriceLine } from '../../../model/price-line';
import Product from 'src/app/model/product/product';

@Component({
  selector: 'price-line-picker',
  templateUrl: './price-line-picker.component.html',
  styleUrls: ['./price-line-picker.component.scss']
})
export class PriceLinePickerComponent implements OnInit {
  public newPriceLine = new PriceLine();

  @Input()
  inputList: PriceLine[];
  @Input()
  inputProduct: Product;
  @Input()
  alignWithBoardPrices = false;

  @Input()
  showSave = false;
  @Input()
  savingLines = false;

  @Output()
  output = new EventEmitter();

  @Output()
  saveLines = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (this.inputList == null) {
      this.inputList = [];
      this.addLine();
    } else if (this.inputList.length < 1) {
      this.addLine();
    }
  }

  priceLineChanged(value, index) {
    this.inputList[index].text = value.text;
    this.inputList[index].price = value.price;
    this.output.emit(this.inputList);
  }

  addLine() {
    if (!this.inputList) {
      this.inputList = [];
    }
    let pl = new PriceLine();
    pl.price = '0';
    pl.text = '';
    if (this.inputProduct != null) {
      pl.product = this.inputProduct;
    }
    this.inputList.push(pl);
  }

  savePrices() {
    this.saveLines.next();
  }

  deleteLine(index) {
    this.inputList.splice(index, 1);
    this.output.emit(this.inputList);
  }
}
